// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"08ad598f","398":"a5b9dd3d","624":"7d0dd233","787":"161a3b21"}[chunkId] + ".chunk.js";
};